export default __webpack_public_path__ + "static/metrocable-arvi-786ea0f60687d052a3185a2d53b45db9.jpg";